<template>
  <v-container id="menus-category">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de menus por categoria"
          home="/administracao"
        />
        <div>
          <menu-category />
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import MenuCategory from '../components/menuCategory.vue'
export default {
  name: 'MenusCategory',
  components: { PageTitle, MenuCategory },
  data: () => ({

  })
}
</script>
<style scoped>
</style>
